import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	margin-top: 30px;
`;

const StyledRegionList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledRegionNumber = styled.div`
	width: 30px;
	height: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	transition: background-color 0.3s ease;

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
		transition: color 0.3s ease;
	}
`;

const StyledRegionItem = styled.div`
	display: grid;
	grid-template-columns: auto 1fr auto;
	align-items: center;
	gap: 10px;

	& > ${Text} {
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
	}

	&:hover {
		${StyledRegionNumber} {
			background-color: #ffffff;

			${Text} {
				color: #000000;
			}
		}
	}
`;

const StyledSearchContainer = styled.div`
	margin-top: 20px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;

	img {
		width: 14px;
		height: 14px;
	}
`;

export {
	StyledButtonContent,
	StyledContainer,
	StyledRegionItem,
	StyledRegionList,
	StyledRegionNumber,
	StyledSearchContainer,
};
